import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 1,
  class: "my-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_attachment_type_control = _resolveComponent("attachment-type-control")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.enabledAttachments.length > 0)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_1, " Přílohy, které jsou součástí odhadu "))
      : _createCommentVNode("", true),
    _createVNode(_component_draggable, {
      modelValue: _ctx.enabledAttachments,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enabledAttachments) = $event)),
      handle: ".card-header",
      onEnd: _ctx.onDragEnd,
      "item-key": (attachmentType) => attachmentType
    }, {
      item: _withCtx(({element: attachmentType}) => [
        _createElementVNode("div", {
          class: "card shadow mb-3",
          id: 'attachment-type-' + attachmentType
        }, [
          _createVNode(_component_attachment_type_control, {
            "attachment-type": attachmentType,
            checked: true,
            attachments: _ctx.attachmentsByType(attachmentType),
            onChanged: _ctx.refresh
          }, null, 8, ["attachment-type", "attachments", "onChanged"])
        ], 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["modelValue", "onEnd", "item-key"]),
    (_ctx.disabledAttachments.length > 0 && _ctx.enabledAttachments.length > 0)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_3, " Přílohy, které nejsou součástí odhadu "))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.disabledAttachments, (attachmentType) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "card shadow mb-3",
        key: attachmentType
      }, [
        _createVNode(_component_attachment_type_control, {
          "attachment-type": attachmentType,
          checked: false,
          attachments: _ctx.attachmentsByType(attachmentType),
          onChanged: _ctx.refresh
        }, null, 8, ["attachment-type", "attachments", "onChanged"])
      ]))
    }), 128))
  ]))
}